import { jwtDecode } from 'jwt-decode';

interface DadosToken {
  Id: string;
  Nome: string;
  CPF: string;
  IdPerfil: string;
  IdInstituicao: string;
  Instituicao: string;
  Claims: string[];
  exp: number;
  iss: string;
}

export class TokenService {
  private static funcionalidadesCache: string[] | null = null;

  static ObterTokenDecodificado(): DadosToken | null {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
      return jwtDecode<DadosToken>(token);
    } catch {
      return null;
    }
  }

  static ObterNomeUsuario(): string {
    const token = this.ObterTokenDecodificado();
    return token?.Nome ?? '';
  }

  static ObterPerfil(): string {
    const token = this.ObterTokenDecodificado();
    return token?.CPF ?? '';
  }

  static ObterFuncionalidades(): string[] {
    if (this.funcionalidadesCache) return this.funcionalidadesCache;

    const token = this.ObterTokenDecodificado();
    if (!token) return [];

    const claims = token.Claims ?? [];
    this.funcionalidadesCache = Array.isArray(claims)
      ? claims.map((c) => c.toLowerCase().trim())
      : [];

    return this.funcionalidadesCache;
  }

  static PossuiFuncionalidade(funcionalidade: string): boolean {
    const funcionalidades = this.ObterFuncionalidades();
    const nome = funcionalidade.toLowerCase().trim();
    return funcionalidades.some((f) => f.includes(nome));
  }

  static ExibirMenu(modulo: string): boolean {
    const funcionalidades = this.ObterFuncionalidades();
    const nomeModulo = modulo.toLowerCase().trim();

    return funcionalidades.some((f) => f.includes(nomeModulo));
  }

  static TokenExpirado(): boolean {
    const token = this.ObterTokenDecodificado();
    if (!token) return true;

    const agora = Math.floor(Date.now() / 1000);
    return token.exp < agora;
  }

  static LogoutForcado() {
    localStorage.clear();
    sessionStorage.clear();
    this.funcionalidadesCache = null;
  }
}
